"use strict";

var _Object$keys2 = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/map"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/values"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _setImmediate2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-immediate"));

var _map2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

function ownKeys(object, enumerableOnly) { var keys = _Object$keys2(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context16; _forEachInstanceProperty2(_context16 = ownKeys(Object(source), true)).call(_context16, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context17; _forEachInstanceProperty2(_context17 = ownKeys(Object(source))).call(_context17, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

require('setimmediate');

var _require = require('./helpers'),
    pick = _require.pick,
    isEmpty = _require.isEmpty,
    omit = _require.omit,
    isPlainObject = _require.isPlainObject,
    isObjectLike = _require.isObjectLike,
    transform = _require.transform,
    get = _require.get,
    set = _require.set,
    toCamelCase = _require.toCamelCase,
    toKebabCase = _require.toKebabCase,
    toSnakeCase = _require.toSnakeCase,
    LRU = _require.LRU;

var _require2 = require('./validator'),
    validateOptions = _require2.validateOptions,
    validateDynamicTypeOptions = _require2.validateDynamicTypeOptions,
    validateError = _require2.validateError;
/**
 * JSONAPISerializer class.
 *
 * @example
 * const JSONAPISerializer = require('json-api-serializer');
 *
 * // Create an instance of JSONAPISerializer with default settings
 * const serializer = new JSONAPISerializer();
 * @class JSONAPISerializer
 * @param {Options} [opts] Global options.
 */


module.exports = /*#__PURE__*/function () {
  function JSONAPISerializer(opts) {
    (0, _classCallCheck2.default)(this, JSONAPISerializer);
    this.opts = opts || {};
    this.schemas = {}; // Size of cache used for convertCase, 0 results in an infinitely sized cache

    var _this$opts$convertCas = this.opts.convertCaseCacheSize,
        convertCaseCacheSize = _this$opts$convertCas === void 0 ? 5000 : _this$opts$convertCas; // Cache of strings to convert to their converted values per conversion type

    this.convertCaseMap = {
      camelCase: new LRU(convertCaseCacheSize),
      kebabCase: new LRU(convertCaseCacheSize),
      snakeCase: new LRU(convertCaseCacheSize)
    };
  }
  /**
   * Register a resource with its type, schema name, and configuration options.
   *
   * @function JSONAPISerializer#register
   * @param {string} type resource's type.
   * @param {string|Options} [schema='default'] schema name.
   * @param {Options} [options] options.
   */


  (0, _createClass2.default)(JSONAPISerializer, [{
    key: "register",
    value: function register(type, schema, options) {
      if ((0, _typeof2.default)(schema) === 'object') {
        options = schema;
        schema = 'default';
      }

      schema = schema || 'default';
      options = _objectSpread(_objectSpread({}, this.opts), options);
      this.schemas[type] = this.schemas[type] || {};
      this.schemas[type][schema] = validateOptions(options);
    }
    /**
     * Serialze input data to a JSON API compliant response.
     * Input data can be a simple object or an array of objects.
     *
     * @see {@link http://jsonapi.org/format/#document-top-level}
     * @function JSONAPISerializer#serialize
     * @param {string|DynamicTypeOptions} type resource's type as string or a dynamic type options as object.
     * @param {object|object[]} data input data.
     * @param {string|object} [schema='default'] resource's schema name.
     * @param {object} [extraData] additional data that can be used in topLevelMeta options.
     * @param {boolean} [excludeData] boolean that can be set to exclude the `data` property in serialized data.
     * @param {object} [overrideSchemaOptions={}] additional schema options, a map of types with options to override.
     * @returns {object|object[]} serialized data.
     */

  }, {
    key: "serialize",
    value: function serialize(type, data, schema, extraData, excludeData) {
      var overrideSchemaOptions = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      // Support optional arguments (schema)
      if (arguments.length === 3) {
        if ((0, _typeof2.default)(schema) === 'object') {
          extraData = schema;
          schema = 'default';
        }
      }

      schema = schema || 'default';
      extraData = extraData || {};
      var included = new _map.default();
      var isDynamicType = (0, _typeof2.default)(type) === 'object';
      var options;

      if (isDynamicType) {
        // Dynamic type option
        options = validateDynamicTypeOptions(type);
      } else {
        // Serialize data with the defined type
        if (!this.schemas[type]) {
          throw new Error("No type registered for ".concat(type));
        }

        if (schema && !this.schemas[type][schema]) {
          var _context;

          throw new Error((0, _concat.default)(_context = "No schema ".concat(schema, " registered for ")).call(_context, type));
        }

        options = this.schemas[type][schema];
      }

      var overrideType = isDynamicType ? type.type : type;

      if (overrideSchemaOptions[overrideType]) {
        // Merge default (registered) options and extra options into new options object
        options = _objectSpread(_objectSpread({}, options), overrideSchemaOptions[overrideType]);
      }

      var dataProperty;

      if (excludeData) {
        dataProperty = undefined;
      } else if (isDynamicType) {
        dataProperty = this.serializeMixedResource(options, data, included, extraData, overrideSchemaOptions);
      } else {
        dataProperty = this.serializeResource(type, data, options, included, extraData, overrideSchemaOptions);
      }

      return {
        jsonapi: options.jsonapiObject ? {
          version: '1.0'
        } : undefined,
        meta: this.processOptionsValues(data, extraData, options.topLevelMeta, 'extraData'),
        links: this.processOptionsValues(data, extraData, options.topLevelLinks, 'extraData'),
        data: dataProperty,
        included: included.size ? (0, _toConsumableArray2.default)((0, _values.default)(included).call(included)) : undefined
      };
    }
    /**
     * Asynchronously serialize input data to a JSON API compliant response.
     * Input data can be a simple object or an array of objects.
     *
     * @see {@link http://jsonapi.org/format/#document-top-level}
     * @function JSONAPISerializer#serializeAsync
     * @param {string|DynamicTypeOptions} type resource's type as string or a dynamic type options as object.
     * @param {object|object[]} data input data.
     * @param {string} [schema='default'] resource's schema name.
     * @param {object} [extraData] additional data that can be used in topLevelMeta options.
     * @param {boolean} [excludeData] boolean that can be set to exclude the `data` property in serialized data.
     * @param {object} [overrideSchemaOptions={}] additional schema options, a map of types with options to override.
     * @returns {Promise} resolves with serialized data.
     */

  }, {
    key: "serializeAsync",
    value: function serializeAsync(type, data, schema, extraData, excludeData) {
      var _this = this;

      var overrideSchemaOptions = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      // Support optional arguments (schema)
      if (arguments.length === 3) {
        if ((0, _typeof2.default)(schema) === 'object') {
          extraData = schema;
          schema = 'default';
        }
      }

      schema = schema || 'default';
      extraData = extraData || {};
      var included = new _map.default();
      var isDataArray = (0, _isArray.default)(data);
      var isDynamicType = (0, _typeof2.default)(type) === 'object';
      var arrayData = isDataArray ? data : [data];
      var serializedData = [];
      var that = this;
      var i = 0;
      var options;

      if (isDynamicType) {
        options = validateDynamicTypeOptions(type);
      } else {
        if (!this.schemas[type]) {
          throw new Error("No type registered for ".concat(type));
        }

        if (schema && !this.schemas[type][schema]) {
          var _context2;

          throw new Error((0, _concat.default)(_context2 = "No schema ".concat(schema, " registered for ")).call(_context2, type));
        }

        options = this.schemas[type][schema];
      }

      var overrideType = isDynamicType ? type.type : type;

      if (overrideSchemaOptions[overrideType]) {
        // Merge default (registered) options and extra options into new options object
        options = _objectSpread(_objectSpread({}, options), overrideSchemaOptions[overrideType]);
      }

      return new _promise.default(function (resolve, reject) {
        /**
         * Non-blocking serialization using the immediate queue.
         *
         * @see {@link https://nodejs.org/en/docs/guides/event-loop-timers-and-nexttick/}
         */
        function next() {
          (0, _setImmediate2.default)(function () {
            if (excludeData) {
              return resolve();
            }

            if (i >= arrayData.length) {
              return resolve(serializedData);
            }

            try {
              // Serialize a single item of the data-array.
              var serializedItem = isDynamicType ? that.serializeMixedResource(type, arrayData[i], included, extraData, overrideSchemaOptions) : that.serializeResource(type, arrayData[i], options, included, extraData, overrideSchemaOptions);

              if (serializedItem !== null) {
                serializedData.push(serializedItem);
              }

              i += 1;
              return next();
            } catch (e) {
              return reject(e);
            }
          });
        }

        next();
      }).then(function (result) {
        var dataProperty;

        if (typeof result === 'undefined') {
          dataProperty = undefined;
        } else if (isDataArray) {
          dataProperty = result;
        } else {
          dataProperty = result[0] || null;
        }

        return {
          jsonapi: options.jsonapiObject ? {
            version: '1.0'
          } : undefined,
          meta: _this.processOptionsValues(data, extraData, options.topLevelMeta, 'extraData'),
          links: _this.processOptionsValues(data, extraData, options.topLevelLinks, 'extraData'),
          // If the source data was an array, we just pass the serialized data array.
          // Otherwise we try to take the first (and only) item of it or pass null.
          data: dataProperty,
          included: included.size ? (0, _toConsumableArray2.default)((0, _values.default)(included).call(included)) : undefined
        };
      });
    }
    /**
     * Deserialize JSON API document data.
     * Input data can be a simple object or an array of objects.
     *
     * @function JSONAPISerializer#deserialize
     * @param {string|DynamicTypeOptions} type resource's type as string or a dynamic type options as object.
     * @param {object} data JSON API input data.
     * @param {string} [schema='default'] resource's schema name.
     * @returns {object} deserialized data.
     */

  }, {
    key: "deserialize",
    value: function deserialize(type, data, schema) {
      var _this2 = this;

      schema = schema || 'default';

      if ((0, _typeof2.default)(type) === 'object') {
        type = validateDynamicTypeOptions(type);
      } else {
        if (!this.schemas[type]) {
          throw new Error("No type registered for ".concat(type));
        }

        if (schema && !this.schemas[type][schema]) {
          var _context3;

          throw new Error((0, _concat.default)(_context3 = "No schema ".concat(schema, " registered for ")).call(_context3, type));
        }
      }

      var deserializedData = {};

      if (data.data) {
        var _context4;

        deserializedData = (0, _isArray.default)(data.data) ? (0, _map2.default)(_context4 = data.data).call(_context4, function (resource) {
          return _this2.deserializeResource(type, resource, schema, data.included);
        }) : this.deserializeResource(type, data.data, schema, data.included);
      }

      return deserializedData;
    }
    /**
     * Asynchronously Deserialize JSON API document data.
     * Input data can be a simple object or an array of objects.
     *
     * @function JSONAPISerializer#deserializeAsync
     * @param {string|DynamicTypeOptions} type resource's type as string or a dynamic type options as object.
     * @param {object} data JSON API input data.
     * @param {string} [schema='default'] resource's schema name.
     * @returns {Promise} resolves with serialized data.
     */

  }, {
    key: "deserializeAsync",
    value: function deserializeAsync(type, data, schema) {
      schema = schema || 'default';

      if ((0, _typeof2.default)(type) === 'object') {
        type = validateDynamicTypeOptions(type);
      } else {
        if (!this.schemas[type]) {
          throw new Error("No type registered for ".concat(type));
        }

        if (schema && !this.schemas[type][schema]) {
          var _context5;

          throw new Error((0, _concat.default)(_context5 = "No schema ".concat(schema, " registered for ")).call(_context5, type));
        }
      }

      var isDataArray = (0, _isArray.default)(data.data);
      var i = 0;
      var arrayData = isDataArray ? data.data : [data.data];
      var deserializedData = [];
      var that = this;
      return new _promise.default(function (resolve, reject) {
        /**
         * Non-blocking deserialization using the immediate queue.
         *
         * @see {@link https://nodejs.org/en/docs/guides/event-loop-timers-and-nexttick/}
         */
        function next() {
          (0, _setImmediate2.default)(function () {
            if (i >= arrayData.length) {
              return resolve(isDataArray ? deserializedData : deserializedData[0]);
            }

            try {
              // Serialize a single item of the data-array.
              var deserializedItem = that.deserializeResource(type, arrayData[i], schema, data.included);
              deserializedData.push(deserializedItem);
              i += 1;
              return next();
            } catch (e) {
              return reject(e);
            }
          });
        }

        next();
      });
    }
    /**
     * Serialize any error into a JSON API error document.
     * Input data can be:
     *  - An `Error` or an array of `Error` instances.
     *  - A JSON API error object or an array of JSON API error objects.
     *
     * @see {@link http://jsonapi.org/format/#errors}
     * @function JSONAPISerializer#serializeError
     * @param {Error|Error[]|object|object[]} error an Error, an array of Error, a JSON API error object, an array of JSON API error object.
     * @returns {object} resolves with serialized error.
     */

  }, {
    key: "serializeError",
    value: function serializeError(error) {
      return {
        errors: (0, _isArray.default)(error) ? (0, _map2.default)(error).call(error, function (err) {
          return validateError(err);
        }) : [validateError(error)]
      };
    }
    /**
     * Deserialize a single JSON API resource.
     * Input data must be a simple object.
     *
     * @function JSONAPISerializer#deserializeResource
     * @private
     * @param {string|DynamicTypeOptions} type resource's type as string or an object with a dynamic type resolved from data.
     * @param {object} data JSON API resource data.
     * @param {string} [schema='default'] resource's schema name.
     * @param {Map<string, object>} included Included resources.
     * @param {string[]} lineage resource identifiers already deserialized to prevent circular references.
     * @returns {object} deserialized data.
     */

  }, {
    key: "deserializeResource",
    value: function deserializeResource(type, data) {
      var _this3 = this;

      var schema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'default';
      var included = arguments.length > 3 ? arguments[3] : undefined;
      var lineage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

      if ((0, _typeof2.default)(type) === 'object') {
        type = typeof type.type === 'function' ? type.type(data) : get(data, type.type);
      }

      if (!type) {
        throw new Error("No type can be resolved from data: ".concat((0, _stringify.default)(data)));
      }

      if (!this.schemas[type]) {
        throw new Error("No type registered for ".concat(type));
      }

      var options = this.schemas[type][schema];
      var deserializedData = {};
      deserializedData[options.id] = data.id || undefined;

      if (data.attributes && options.whitelistOnDeserialize.length) {
        data.attributes = pick(data.attributes, options.whitelistOnDeserialize);
      }

      if (data.attributes && options.blacklistOnDeserialize.length) {
        data.attributes = omit(data.attributes, options.blacklistOnDeserialize);
      }

      (0, _assign.default)(deserializedData, data.attributes); // Deserialize relationships

      if (data.relationships) {
        var _context6;

        (0, _forEach.default)(_context6 = (0, _keys.default)(data.relationships)).call(_context6, function (relationshipProperty) {
          var relationship = data.relationships[relationshipProperty];
          var relationshipKey = options.unconvertCase ? _this3._convertCase(relationshipProperty, options.unconvertCase) : relationshipProperty;
          var relationshipOptions = options.relationships[relationshipKey];

          var deserializeFunction = function deserializeFunction(relationshipData) {
            if (relationshipOptions && relationshipOptions.deserialize) {
              return relationshipOptions.deserialize(relationshipData);
            }

            return {
              id: relationshipData.id
            };
          };

          if (relationship.data !== undefined) {
            if (relationship.data === null) {
              // null data
              set(deserializedData, relationshipOptions && relationshipOptions.alternativeKey || relationshipKey, null);
            } else {
              if (relationshipOptions && relationshipOptions.alternativeKey || !included) {
                var _context7;

                set(deserializedData, relationshipOptions && relationshipOptions.alternativeKey || relationshipKey, (0, _isArray.default)(relationship.data) ? (0, _map2.default)(_context7 = relationship.data).call(_context7, function (d) {
                  return deserializeFunction(d);
                }) : deserializeFunction(relationship.data));
              }

              if (included) {
                var _context9;

                var deserializeIncludedRelationship = function deserializeIncludedRelationship(relationshipData) {
                  var _context8;

                  var lineageCopy = (0, _toConsumableArray2.default)(lineage); // Prevent circular relationships

                  var lineageKey = (0, _concat.default)(_context8 = "".concat(relationshipData.type, "-")).call(_context8, relationshipData.id);
                  var isCircular = (0, _includes.default)(lineageCopy).call(lineageCopy, lineageKey);

                  if (isCircular) {
                    return deserializeFunction(relationshipData);
                  }

                  lineageCopy.push(lineageKey);
                  return _this3.deserializeIncluded(relationshipData.type, relationshipData.id, relationshipOptions, included, lineageCopy, deserializeFunction);
                };

                var deserializedIncludedRelationship = (0, _isArray.default)(relationship.data) ? (0, _map2.default)(_context9 = relationship.data).call(_context9, function (d) {
                  return deserializeIncludedRelationship(d);
                }) : deserializeIncludedRelationship(relationship.data); // not set to deserializedData if alternativeKey is set and relationship data is not in the included array (value is the same as alternativeKey value)

                if (!(relationshipOptions && relationshipOptions.alternativeKey && deserializedIncludedRelationship.toString() === get(deserializedData, relationshipOptions.alternativeKey).toString())) {
                  set(deserializedData, relationshipKey, deserializedIncludedRelationship);
                }
              }
            }
          }
        });
      }

      if (options.unconvertCase) {
        deserializedData = this._convertCase(deserializedData, options.unconvertCase);
      }

      if (data.links) {
        deserializedData.links = data.links;
      }

      if (data.meta) {
        deserializedData.meta = data.meta;
      }

      if (options.afterDeserialize) {
        return options.afterDeserialize(deserializedData);
      }

      return deserializedData;
    }
    /**
     * Deserialize included
     *
     * @function JSONAPISerializer#deserializeIncluded
     * @private
     * @param {string} type resource's type as string or an object with a dynamic type resolved from data.
     * @param {string} id identifier of the resource.
     * @param {RelationshipOptions} relationshipOpts relationship option.
     * @param {Map<string, object>} included Included resources.
     * @param {string[]} lineage resource identifiers already deserialized to prevent circular references.
     * @param {Function} deserializeFunction a deserialize function
     * @returns {object} deserialized data.
     */

  }, {
    key: "deserializeIncluded",
    value: function deserializeIncluded(type, id, relationshipOpts, included, lineage, deserializeFunction) {
      var includedResource = (0, _find.default)(included).call(included, function (resource) {
        return resource.type === type && resource.id === id;
      });

      if (!includedResource) {
        return deserializeFunction({
          type: type,
          id: id
        });
      }

      return this.deserializeResource(type, includedResource, relationshipOpts.schema, included, lineage);
    }
    /**
     * Serialize resource objects.
     *
     * @see {@link http://jsonapi.org/format/#document-resource-objects}
     * @function JSONAPISerializer#serializeDocument
     * @private
     * @param {string} type resource's type.
     * @param {object|object[]} data input data.
     * @param {Options} options resource's configuration options.
     * @param {Map<string, object>} [included] Included resources.
     * @param {object} [extraData] additional data.
     * @param {object} [overrideSchemaOptions={}] additional schema options, a map of types with options to override.
     * @returns {object|object[]} serialized data.
     */

  }, {
    key: "serializeResource",
    value: function serializeResource(type, data, options, included, extraData) {
      var _this4 = this;

      var overrideSchemaOptions = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (isEmpty(data)) {
        // Return [] or null
        return (0, _isArray.default)(data) ? data : null;
      }

      if ((0, _isArray.default)(data)) {
        return (0, _map2.default)(data).call(data, function (d) {
          return _this4.serializeResource(type, d, options, included, extraData, overrideSchemaOptions);
        });
      }

      if (options.beforeSerialize) {
        data = options.beforeSerialize(data);
      }

      return {
        type: type,
        id: data[options.id] ? data[options.id].toString() : undefined,
        attributes: this.serializeAttributes(data, options),
        relationships: this.serializeRelationships(data, options, included, extraData, overrideSchemaOptions),
        meta: this.processOptionsValues(data, extraData, options.meta),
        links: this.processOptionsValues(data, extraData, options.links)
      };
    }
    /**
     * Serialize mixed resource object with a dynamic type resolved from data
     *
     * @see {@link http://jsonapi.org/format/#document-resource-objects}
     * @function JSONAPISerializer#serializeMixedResource
     * @private
     * @param {DynamicTypeOptions} typeOption a dynamic type options.
     * @param {object|object[]} data input data.
     * @param {Map<string, object>} [included] Included resources.
     * @param {object} [extraData] additional data.
     * @param {object} [overrideSchemaOptions={}] additional schema options, a map of types with options to override.
     * @returns {object|object[]} serialized data.
     */

  }, {
    key: "serializeMixedResource",
    value: function serializeMixedResource(typeOption, data, included, extraData) {
      var _this5 = this;

      var overrideSchemaOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

      if (isEmpty(data)) {
        // Return [] or null
        return (0, _isArray.default)(data) ? data : null;
      }

      if ((0, _isArray.default)(data)) {
        return (0, _map2.default)(data).call(data, function (d) {
          return _this5.serializeMixedResource(typeOption, d, included, extraData, overrideSchemaOptions);
        });
      } // Resolve type from data (can be a string or a function deriving a type-string from each data-item)


      var type = typeof typeOption.type === 'function' ? typeOption.type(data) : get(data, typeOption.type);

      if (!type) {
        throw new Error("No type can be resolved from data: ".concat((0, _stringify.default)(data)));
      }

      if (!this.schemas[type]) {
        throw new Error("No type registered for ".concat(type));
      }

      var options = this.schemas[type].default;

      if (overrideSchemaOptions[type]) {
        // Merge default (registered) options and extra options into new options object
        options = _objectSpread(_objectSpread({}, options), overrideSchemaOptions[type]);
      }

      return this.serializeResource(type, data, options, included, extraData, overrideSchemaOptions);
    }
    /**
     * Serialize 'attributes' key of resource objects: an attributes object representing some of the resource's data.
     *
     * @see {@link http://jsonapi.org/format/#document-resource-object-attributes}
     * @function JSONAPISerializer#serializeAttributes
     * @private
     * @param {object|object[]} data input data.
     * @param {Options} options resource's configuration options.
     * @returns {object} serialized attributes.
     */

  }, {
    key: "serializeAttributes",
    value: function serializeAttributes(data, options) {
      var _context10, _context11;

      if (options.whitelist && options.whitelist.length) {
        data = pick(data, options.whitelist);
      } // Support alternativeKey options for relationships


      var alternativeKeys = [];
      (0, _forEach.default)(_context10 = (0, _keys.default)(options.relationships)).call(_context10, function (key) {
        var rOptions = options.relationships[key];

        if (rOptions.alternativeKey) {
          alternativeKeys.push(rOptions.alternativeKey);
        }
      }); // Remove unwanted keys

      var serializedAttributes = omit(data, (0, _concat.default)(_context11 = [options.id]).call(_context11, (0, _toConsumableArray2.default)((0, _keys.default)(options.relationships)), alternativeKeys, (0, _toConsumableArray2.default)(options.blacklist)));

      if (options.convertCase) {
        serializedAttributes = this._convertCase(serializedAttributes, options.convertCase);
      }

      return (0, _keys.default)(serializedAttributes).length ? serializedAttributes : undefined;
    }
    /**
     * Serialize 'relationships' key of resource objects: a relationships object describing relationships between the resource and other JSON API resources.
     *
     * @see {@link http://jsonapi.org/format/#document-resource-object-relationships}
     * @function JSONAPISerializer#serializeRelationships
     * @private
     * @param {object|object[]} data input data.
     * @param {Options} options resource's configuration options.
     * @param {Map<string, object>} [included]  Included resources.
     * @param {object} [extraData] additional data.
     * @param {object} [overrideSchemaOptions={}] additional schema options, a map of types with options to override.
     * @returns {object} serialized relationships.
     */

  }, {
    key: "serializeRelationships",
    value: function serializeRelationships(data, options, included, extraData) {
      var _context12,
          _this6 = this;

      var overrideSchemaOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var serializedRelationships = {};
      (0, _forEach.default)(_context12 = (0, _keys.default)(options.relationships)).call(_context12, function (relationship) {
        var relationshipOptions = options.relationships[relationship]; // Support alternativeKey options for relationships

        var relationshipKey = relationship;

        if (!data[relationship] && relationshipOptions.alternativeKey) {
          relationshipKey = relationshipOptions.alternativeKey;
        }

        var serializeRelationship = {
          links: _this6.processOptionsValues(data, extraData, relationshipOptions.links),
          meta: _this6.processOptionsValues(data, extraData, relationshipOptions.meta),
          data: _this6.serializeRelationship(relationshipOptions.type, relationshipOptions.schema, get(data, relationshipKey), included, data, extraData, overrideSchemaOptions)
        };

        if (serializeRelationship.data !== undefined || serializeRelationship.links !== undefined || serializeRelationship.meta !== undefined) {
          // Convert case
          relationship = options.convertCase ? _this6._convertCase(relationship, options.convertCase) : relationship;
          serializedRelationships[relationship] = serializeRelationship;
        }
      });
      return (0, _keys.default)(serializedRelationships).length ? serializedRelationships : undefined;
    }
    /**
     * Serialize 'data' key of relationship's resource objects.
     *
     * @see {@link http://jsonapi.org/format/#document-resource-object-linkage}
     * @function JSONAPISerializer#serializeRelationship
     * @private
     * @param {string|Function} rType the relationship's type.
     * @param {string} rSchema the relationship's schema
     * @param {object|object[]} rData relationship's data.
     * @param {Map<string, object>} [included] Included resources.
     * @param {object} [data] the entire resource's data.
     * @param {object} [extraData] additional data.
     * @param {object} [overrideSchemaOptions={}] additional schema options, a map of types with options to override.
     * @returns {object|object[]} serialized relationship data.
     */

  }, {
    key: "serializeRelationship",
    value: function serializeRelationship(rType, rSchema, rData, included, data, extraData) {
      var _this7 = this;

      var overrideSchemaOptions = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
      included = included || new _map.default();
      var schema = rSchema || 'default'; // No relationship data

      if (rData === undefined || rData === null) {
        return rData;
      }

      if ((0, _typeof2.default)(rData) === 'object' && isEmpty(rData)) {
        // Return [] or null
        return (0, _isArray.default)(rData) ? [] : null;
      }

      if ((0, _isArray.default)(rData)) {
        return (0, _map2.default)(rData).call(rData, function (d) {
          return _this7.serializeRelationship(rType, schema, d, included, data, extraData, overrideSchemaOptions);
        });
      } // Resolve relationship type


      var type = typeof rType === 'function' ? rType(rData, data) : rType;

      if (!type) {
        throw new Error("No type can be resolved from relationship's data: ".concat((0, _stringify.default)(rData)));
      }

      if (!this.schemas[type]) {
        throw new Error("No type registered for \"".concat(type, "\""));
      }

      if (!this.schemas[type][schema]) {
        var _context13;

        throw new Error((0, _concat.default)(_context13 = "No schema \"".concat(schema, "\" registered for type \"")).call(_context13, type, "\""));
      }

      var rOptions = this.schemas[type][schema];

      if (overrideSchemaOptions[type]) {
        // Merge default (registered) options and extra options into new options object
        rOptions = _objectSpread(_objectSpread({}, rOptions), overrideSchemaOptions[type]);
      }

      var serializedRelationship = {
        type: type
      }; // Support for unpopulated relationships (an id, or array of ids)

      if (!isObjectLike(rData)) {
        serializedRelationship.id = rData.toString();
      } else {
        var _context14;

        var serializedIncluded = this.serializeResource(type, rData, rOptions, included, extraData, overrideSchemaOptions);
        serializedRelationship.id = serializedIncluded.id;
        var identifier = (0, _concat.default)(_context14 = "".concat(type, "-")).call(_context14, serializedRelationship.id); // Not include relationship object which only contains an id

        if (serializedIncluded.attributes && (0, _keys.default)(serializedIncluded.attributes).length) {
          // Merge relationships data if already included
          if (included.has(identifier)) {
            var alreadyIncluded = included.get(identifier);

            if (serializedIncluded.relationships) {
              alreadyIncluded.relationships = _objectSpread(_objectSpread({}, alreadyIncluded.relationships), serializedIncluded.relationships);
              included.set(identifier, alreadyIncluded);
            }
          } else {
            included.set(identifier, serializedIncluded);
          }
        }
      }

      return serializedRelationship;
    }
    /**
     * Process options values.
     * Allows options to be an object or a function with 1 or 2 arguments
     *
     * @function JSONAPISerializer#processOptionsValues
     * @private
     * @param {object} data data passed to functions options.
     * @param {object} extraData additional data passed to functions options.
     * @param {object} options configuration options.
     * @param {string} [fallbackModeIfOneArg] fallback mode if only one argument is passed to function.
     * Avoid breaking changes with issue https://github.com/danivek/json-api-serializer/issues/27.
     * @returns {object} processed options.
     */

  }, {
    key: "processOptionsValues",
    value: function processOptionsValues(data, extraData, options, fallbackModeIfOneArg) {
      var processedOptions = {};

      if (options && typeof options === 'function') {
        // Backward compatible with functions with one 'extraData' argument
        processedOptions = fallbackModeIfOneArg === 'extraData' && options.length === 1 ? options(extraData) : options(data, extraData);
      } else {
        var _context15;

        (0, _forEach.default)(_context15 = (0, _keys.default)(options)).call(_context15, function (key) {
          var processedValue = {};

          if (options[key] && typeof options[key] === 'function') {
            // Backward compatible with functions with one 'extraData' argument
            processedValue = fallbackModeIfOneArg === 'extraData' && options[key].length === 1 ? options[key](extraData) : options[key](data, extraData);
          } else {
            processedValue = options[key];
          }

          (0, _assign.default)(processedOptions, (0, _defineProperty2.default)({}, key, processedValue));
        });
      }

      return processedOptions && (0, _keys.default)(processedOptions).length ? processedOptions : undefined;
    }
    /**
     * Recursively convert object keys case
     *
     * @function JSONAPISerializer#_convertCase
     * @private
     * @param {object|object[]|string} data to convert
     * @param {string} convertCaseOptions can be snake_case', 'kebab-case' or 'camelCase' format.
     * @returns {object} Object with it's keys converted as per the convertCaseOptions
     */

  }, {
    key: "_convertCase",
    value: function _convertCase(data, convertCaseOptions) {
      var _this8 = this;

      if ((0, _isArray.default)(data)) {
        return (0, _map2.default)(data).call(data, function (item) {
          if (item && ((0, _isArray.default)(item) || isPlainObject(item))) {
            return _this8._convertCase(item, convertCaseOptions);
          }

          return item;
        });
      }

      if (isPlainObject(data)) {
        return transform(data, function (result, value, key) {
          var converted;

          if (value && ((0, _isArray.default)(value) || isPlainObject(value))) {
            converted = _this8._convertCase(value, convertCaseOptions);
          } else {
            converted = value;
          }

          result[_this8._convertCase(key, convertCaseOptions)] = converted;
          return result;
        }, {});
      }

      if (typeof data === 'string') {
        var converted;

        switch (convertCaseOptions) {
          case 'snake_case':
            converted = this.convertCaseMap.snakeCase.get(data);

            if (!converted) {
              converted = toSnakeCase(data);
              this.convertCaseMap.snakeCase.set(data, converted);
            }

            break;

          case 'kebab-case':
            converted = this.convertCaseMap.kebabCase.get(data);

            if (!converted) {
              converted = toKebabCase(data);
              this.convertCaseMap.kebabCase.set(data, converted);
            }

            break;

          case 'camelCase':
            converted = this.convertCaseMap.camelCase.get(data);

            if (!converted) {
              converted = toCamelCase(data);
              this.convertCaseMap.camelCase.set(data, converted);
            }

            break;

          default: // Do nothing

        }

        return converted;
      }

      return data;
    }
  }]);
  return JSONAPISerializer;
}();
/**
 * @typedef {object} Options
 * @property {string} [id='id'] the key to use as the reference. Default = 'id'
 * @property {string[]} [blacklist=[]] an array of blacklisted attributes. Default = []
 * @property {string[]} [whitelist=[]] an array of whitelisted attributes. Default = []
 * @property {boolean} [jsonapiObject=true] enable/Disable JSON API Object. Default = true
 * @property {Function|object} [links] describes the links inside data
 * @property {Function|object} [topLevelLinks] describes the top-level links
 * @property {Function|object} [topLevelMeta] describes the top-level meta
 * @property {Function|object} [meta] describes resource-level meta
 * @property {object.<string, RelationshipOptions>} [relationships] an object defining some relationships
 * @property {string[]} [blacklistOnDeserialize=[]] an array of blacklisted attributes. Default = []
 * @property {string[]} [whitelistOnDeserialize=[]] an array of whitelisted attributes. Default = []
 * @property {('kebab-case'|'snake_case'|'camelCase')} [convertCase] case conversion for serializing data
 * @property {('kebab-case'|'snake_case'|'camelCase')} [unconvertCase] case conversion for deserializing data
 * @property {number} [convertCaseCacheSize=5000] When using convertCase, a LRU cache is utilized for optimization. The default size of the cache is 5000 per conversion type.
 * @property {Function} [beforeSerialize] a function to transform data before serialization.
 * @property {Function} [afterDeserialize] a function to transform data after deserialization.
 */

/**
 * @typedef {object} RelationshipOptions
 * @property {string|Function} type a string or a function for the type to use for serializing the relationship (type need to be register)
 * @property {string} [alternativeKey] an alternative key (string or path) to use if relationship key not exist (example: 'author_id' as an alternative key for 'author' relationship)
 * @property {string} [schema] a custom schema for serializing the relationship. If no schema define, it use the default one.
 * @property {Function|object} [links] describes the links for the relationship
 * @property {Function|object} [meta] describes meta that contains non-standard meta-information about the relationship
 * @property {Function} [deserialize] describes the function which should be used to deserialize a related property which is not included in the JSON:API document
 */

/**
 *
 * @typedef {object} DynamicTypeOptions
 * @property {string} id a string for the path to the key to use to determine type or a function deriving a type-string from each data-item.
 * @property {boolean} [jsonapiObject=true] enable/Disable JSON API Object.
 * @property {Function|object} [topLevelLinks] describes the top-level links
 * @property {Function|object} [topLevelMeta] describes the top-level meta.
 */
//# sourceMappingURL=JSONAPISerializer.js.map